import { useEffect } from 'react';
import api from '../services/api';

/**
 * Enregistre une consultation de feature (fire-and-forget), pour un événement ponctuel
 * (clic, ouverture d'onglet). Échec silencieux : rien ne doit gêner l'utilisateur.
 * Le serveur ignore les appels d'un admin en simulation.
 */
export function pingFeature(featureKey) {
    if (!featureKey) return;
    api.post('/user/feature-ping.php', { feature: featureKey })
        .catch(() => { /* fire-and-forget */ });
}

/**
 * Hook : enregistre une consultation de feature (fire-and-forget).
 *
 * Usage :
 *   useFeaturePing('history');
 *
 * Le ping ne se lance qu'une fois par mount (dépendance stable).
 * Échec silencieux : un user non-auth ou un network down ne bloque rien.
 */
export default function useFeaturePing(featureKey) {
    useEffect(() => {
        pingFeature(featureKey);
    }, [featureKey]);
}
